define([
    'vue',
    'WebCommon/toast/loading',
    'jquery'
], function(
    Vue,
    LoadingToast,
    $
){
    var $toastOverlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $toastOverlay[0],
        template: '<loading-toast v-show="loadingToast.isShow"></loading-toast>',
        components: {
            LoadingToast: LoadingToast
        },
        data: {
            loadingToast: {
                isShow: false
            }
        },
        methods: {
            showLoadingToast: function(){
                this.loadingToast.isShow = true;
            },
            hideLoadingToast: function(){
                this.loadingToast.isShow = false;
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ../common/toast/toast.js
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7 8 9